import { ACTION_TYPES } from "../constants/actionTypes";
import { NotificationManager } from 'react-notifications';
import { fetchTreeSpecies,fetchHealthRates, fetchRecomendations, fetchTrees, saveTree, updateTree, deleteTree, fetchJurisdiction}  from "../API";

export const fetchSpecies =()=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.FETCH_SPECIES_REQUEST})
        const {data} = await fetchTreeSpecies();
        dispatch({type: ACTION_TYPES.FETCH_SPECIES_SUCCESS, payload: data.data})
    }
    catch(err){
        console.log(err.message)
        dispatch({type: ACTION_TYPES.FETCH_SPECIES_FAILED})
        NotificationManager.error(err.message)
    }
}

export const fetchHealthRate =()=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.FETCH_HEALTHRATE_REQUEST})
        const {data} = await fetchHealthRates();
        dispatch({type: ACTION_TYPES.FETCH_HEALTHRATE_SUCCESS, payload: data.data})
    }
    catch(err){
        console.log(err.message)
        dispatch({type: ACTION_TYPES.FETCH_HEALTHRATE_FAILED})
        NotificationManager.error(err.message)
    }
}

export const fetchRecomendation =()=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.FETCH_RECOMENDATIONS_REQUEST})
        const {data} = await fetchRecomendations();
        dispatch({type: ACTION_TYPES.FETCH_RECOMENDATIONS_SUCCESS, payload: data.data})
    }
    catch(err){
        console.log(err.message)
        dispatch({type: ACTION_TYPES.FETCH_RECOMENDATIONS_FAILED})
        NotificationManager.error(err.message)
    }
}

export const getJurisdiction =()=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.FETCH_JURISDICTION_REQUEST})
        const {data} = await fetchJurisdiction()
        console.log("data", data)
        dispatch({type: ACTION_TYPES.FETCH_JURISDICTION_SUCCESS, payload: data.data})
    }catch(err){
        console.log(err)
        dispatch({type: ACTION_TYPES.FETCH_JURISDICTION_FAILED})
        NotificationManager.error(err.message)
    }
}
export const fetchAllTrees = (reportId)=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.FETCH_TREE_REQUEST})
        const {data} = await fetchTrees(reportId)
        dispatch({type: ACTION_TYPES.FETCH_TREE_SUCCESS, payload: data.data})
    }
    catch(err){
        console.log(err.message)
        dispatch({type: ACTION_TYPES.FETCH_TREE_FAILED})
        NotificationManager.error(err.message)
    }
}

export const addTree =(reportId, res)=> async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.SAVE_TREE_REQUEST})
        const {data} = await saveTree(reportId, res)
        console.log("data", data)
        dispatch({type: ACTION_TYPES.SAVE_TREE_SUCCESS, payload: data.data})
    }
    catch(err){
        console.log(err)
        dispatch({type: ACTION_TYPES.SAVE_TREE_FAILED})
        NotificationManager.error(err.message)
    }
}

export const setTree =(res)=>async(dispatch, getState)=>{   
    try{
        dispatch({type: ACTION_TYPES.SET_TREE_REQUEST})
        console.log("res", res)
        dispatch({type: ACTION_TYPES.SET_TREE_SUCCESS, payload:res})
    }
    catch(err){
        console.log(err.message);
        dispatch({type:ACTION_TYPES.SET_TREE_FAILED})
        NotificationManager.error(err.response ? err.response.data.msg : err.message)
    }
}

export const editTree =(reportId,treeId,res)=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.EDIT_TREE_REQUEST})
        const {data} = await updateTree(reportId,treeId, res)
        dispatch({type: ACTION_TYPES.EDIT_TREE_SUCCESS, payload:data.data})

    }
    catch(err){
        console.log(err)
        dispatch({type: ACTION_TYPES.EDIT_TREE_FAILED})
        NotificationManager.error(err.message)
    }
}

export const deleteReportTree =(reportId, treeId)=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.DELETE_TREE_REQUEST})
        const {data} = await deleteTree(reportId, treeId)
        dispatch({type: ACTION_TYPES.DELETE_TREE_SUCCESS})
        NotificationManager.success(data.msg) 
        dispatch(fetchAllTrees(reportId))
    }
    catch(err){
        console.log(err.message)
        dispatch({type: ACTION_TYPES.DELETE_TREE_FAILED})
        NotificationManager.error(err.message)
    }
}